function getUrlWithoutAuthParams(absolute) {
  const { origin, pathname } = location;
  const query = getSearchQueryWithoutAuthParams(location.search);
  const relativeUrl = query ? `${pathname}?${query}` : pathname;
  return absolute ? `${origin}${relativeUrl}` : relativeUrl;
}
const authParams = {
  authCode: "code",
  authScope: "scope",
  authState: "state",
  authSessionState: "session_state",
  authError: "error",
  authErrorDescription: "error_description"
};
function checkAuthQueryParams(searchString) {
  const searchParams = new URLSearchParams(searchString);
  return Object.values(authParams).some((p) => searchParams.has(p));
}
function getRedirectUrls(origin) {
  const relativeUrl = getUrlWithoutAuthParams(false);
  const absoluteUrl = getUrlWithoutAuthParams(true);
  return {
    relativeUrl,
    absoluteUrl: origin ? `${origin}${relativeUrl}` : absoluteUrl
  };
}
function getSearchQueryWithoutAuthParams(searchString) {
  const searchParams = new URLSearchParams(searchString);
  searchParams.delete(authParams.authCode);
  searchParams.delete(authParams.authScope);
  searchParams.delete(authParams.authSessionState);
  searchParams.delete(authParams.authState);
  searchParams.delete(authParams.authError);
  searchParams.delete(authParams.authErrorDescription);
  return searchParams.toString();
}
function getPolicies(user) {
  const policies = user?.profile?.policies;
  let result = (user?.scopes ?? []).concat();
  if (policies) {
    if (typeof policies === "string") {
      result = result.concat([policies]);
    } else {
      const flatPolicies = Object.values(policies ?? {}).flat();
      result.push(...flatPolicies);
    }
  }
  return [...new Set(result)];
}
export {
  checkAuthQueryParams,
  getPolicies,
  getRedirectUrls,
  getSearchQueryWithoutAuthParams
};
//# sourceMappingURL=utils.js.map
